module.exports = __webpack_public_path__ + "media/components/assets/img/bg/fields-9c91e492ee1eeaec69334042ff389eb6.svg";